<template>
  <v-container>
    <v-card elevation="0" width="100%" height="100%">
      <v-card-title style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">จัดหมวดหมู่สินค้า</v-card-title>
      <v-card-title class="px-0" style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;" v-else>
        <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> จัดหมวดหมู่สินค้า
      </v-card-title>
      <v-row no-gutters class="mx-2">
        <v-col cols="12" class="py-0 pr-2">
          <a-tabs @change="getRequest">
            <a-tab-pane :key="0"><span slot="tab">ทั้งหมด <a-tag color="#27AB9C" style="border-radius: 8px;">{{ countAll }}</a-tag></span></a-tab-pane>
            <a-tab-pane :key="1"><span slot="tab">กำลังใช้งาน <a-tag color="#1AB759" style="border-radius: 8px;">{{ countActive }}</a-tag></span></a-tab-pane>
            <a-tab-pane :key="2"><span slot="tab">ปิดการใช้งาน <a-tag color="#F5222D" style="border-radius: 8px;">{{ countInactive }}</a-tag></span></a-tab-pane>
          </a-tabs>
        </v-col>
        <v-col cols="12" md="6" sm="12" class="" :class="!MobileSize ? 'pl-0 pr-3 mb-3 pt-3' : 'pl-0 pr-2 mb-3 pt-3'">
          <v-text-field v-model="search" placeholder="ค้นหาหมวดหมู่สินค้า" outlined dense hide-details>
            <v-icon slot="append" color="#27AB9C">mdi-magnify</v-icon>
          </v-text-field>
        </v-col>
        <v-col cols="12" md="12" sm="12" class="pt-3 pb-3">
          <v-row dense>
            <v-col cols="12" md="6" sm="7" class="pt-2">
              <span class="fontCount" v-if="StateStatus === 0">รายการหมวดหมู่สินค้าทั้งหมด {{ showCountRequest }} รายการ</span>
              <span class="fontCount" v-else-if="StateStatus === 1">รายการหมวดหมู่สินค้าที่กำลังใช้งาน {{ showCountRequest }} รายการ</span>
              <span class="fontCount" v-else-if="StateStatus === 2">รายการหมวดหมู่สินค้าที่ปิดการใช้งาน {{ showCountRequest }} รายการ</span>
            </v-col>
            <v-col cols="12" md="6" sm="5" class="pt-0" align="right">
              <v-btn @click="dialogAddEdit = true" :width="MobileSize ? '100%' : ''" dense color="#27AB9C" :class="MobileSize || IpadSize ? 'white--text' : 'ml-4 pl-8 pr-8 white--text'">
                <v-icon>mdi-plus-circle-outline</v-icon>
                เพิ่มหมวดหมู่สินค้า
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" v-if="disableTable === false" class="mt-2">
          <v-data-table
          :headers="headers"
          :items="catagoryList"
          :search="search"
          :page.sync="page"
          @pagination="countRequest"
          no-results-text="ไม่พบหมวดหมู่สินค้า"
          no-data-text="ไม่มีหมวดหมู่สินค้า"
          @update:items-per-page="itemsPerPage"
          :footer-props="{'items-per-page-text':'จำนวนแถว'}"
          :items-per-page="10"
          class="elevation-1"
          >
            <template v-slot:[`item.created_at`]="{ item }">
              <span v-if="item.created_at !== null">{{ formatDateTH(item.created_at) }}</span>
              <span v-else>-</span>
            </template>
            <template v-slot:[`item.status`]="{ item }">
                <span v-if="item.status">
                  <v-chip small color="#F0F9EE" text-color="#1AB759">กำลังใช้งาน</v-chip>
                </span>
                <span v-else>
                  <v-chip small color="#F9EEEE" text-color="#F5222D">ปิดการใช้งาน</v-chip>
                </span>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-row>
                <v-col class="pr-0">
                  <v-tooltip top color="#27AB9C">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs" v-on="on"
                        x-small
                        @click="edit(item.id)"
                        style="border: 1px solid #F2F2F2; box-sizing: border-box; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04); border-radius: 4px;"
                        outlined
                        class="pt-4 pb-4"
                        :style="IpadProSize ? 'max-width: 24px; max-height: 24px;' : IpadSize ? 'max-width: 16px; max-height: 16px;' : 'max-width: 32px; max-height: 32px;'"
                        >
                          <v-icon color="#27AB9C" :size="18">mdi-pencil-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>แก้ไข</span>
                  </v-tooltip>
                </v-col>
                <v-col class="pl-0">
                  <v-tooltip top color="#27AB9C">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :disabled="item.have_prouduct === 'yes'"
                        v-bind="attrs" v-on="on"
                        x-small
                        @click="dlt(item.id)"
                        style="border: 1px solid #F2F2F2; box-sizing: border-box; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04); border-radius: 4px;"
                        outlined
                        class="pt-4 pb-4"
                        :style="IpadProSize ? 'max-width: 24px; max-height: 24px;' : IpadSize ? 'max-width: 16px; max-height: 16px;' : 'max-width: 32px; max-height: 32px;'"
                        >
                          <v-icon color="#27AB9C" :size="18">mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>ลบ</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.switch`]="{ item }">
              <v-row>
                <v-col cols="4">
                  <v-switch :ripple="false" class="hide-background-hover align-center custom-switch" v-model="item.status" :disabled="item.have_prouduct === 'yes'" color="#52C41A" inset hide-details @click="switchStatus(item.id, item.status)"></v-switch>
                </v-col>
                <v-col cols="8" v-if="item.have_prouduct === 'yes'" :class="IpadSize ? '' : ''">
                  <span style="font-size: 12px; color: #F5222D;">ถูกใช้งานอยู่</span>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-col>
        <v-col cols="12" v-if="disableTable === true" align="center">
          <div class="my-5">
            <v-img src="@/assets/emptypo.png" max-height="500px" max-width="500px" height="100%" width="100%" contain aspect-ratio="2"></v-img>
          </div>
          <h2 style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;" v-if="StateStatus === 0">ไม่มีรายการหมวดหมู่สินค้า</h2>
          <h2 style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;" v-if="StateStatus === 1">ไม่มีรายการหมวดหมู่สินค้าที่กำลังใช้งาน</h2>
          <h2 style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;" v-if="StateStatus === 2">ไม่มีรายการหมวดหมู่สินค้าที่ปิดการใช้งาน</h2>
          <h2 style="padding-bottom: 50px; color: #27AB9C;" v-if="countAll < 0">กรุณากดที่ปุ่ม <b>“เพิ่มหมวดหมู่สินค้า”</b> เพื่อรายการที่สมบูรณ์</h2>
        </v-col>
      </v-row>

      <!-- dialog Add Catagories -->
      <v-dialog width="588px" v-model="dialogAddEdit" persistent>
        <v-card style="overflow: hidden">
          <v-toolbar color="#BDE7D9" dark dense elevation="0">
            <span class="flex text-center ml-5" style="font-weight: 700; font-size: 20px; line-height: 30px; color: #27AB9C;" v-if="status !== 'edit'">เพิ่มหมวดหมู่สินค้า</span>
            <span class="flex text-center ml-5" style="font-weight: 700; font-size: 20px; line-height: 30px; color: #27AB9C;" v-else>แก้ไขหมวดหมู่สินค้า</span>
            <v-btn icon dark @click="closeDialog()">
              <v-icon color="#27AB9C">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container grid-list-xs>
            <v-row class="px-5">
              <v-col cols="12">
                <v-img class="float-left" src="@/assets/ICON/GraczBuyer.png" contain width="60px" height="60px"></v-img>
                <v-card-title style="font-weight: bold; font-size: 18px; line-height: 26px; color: #333333;" v-if="status !== 'edit'">เพิ่มหมวดหมู่สินค้า</v-card-title>
                <v-card-title style="font-weight: bold; font-size: 18px; line-height: 26px; color: #333333;" v-else>แก้ไขหมวดหมู่สินค้า</v-card-title>
              </v-col>
            </v-row>
            <v-row class="pt-6" no-gutters justify="center">
              <v-col cols="9" >
                <v-text-field v-model="catagoryName" maxlength="20" placeholder="ระบุชื่อหมวดหมู่สินค้า" outlined dense hide-details></v-text-field>
              </v-col>
            </v-row>
            <v-card-actions class="px-5 mt-4">
              <v-spacer></v-spacer>
              <v-btn outlined color="#27AB9C" @click="closeDialog()">ยกเลิก</v-btn>
              <v-btn class="white--text" color="#27AB9C" :disabled="catagoryName == '' ? true : false" @click="dialogAddEdit = false, dialogConfirmAddEdit = true">บันทึก</v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>

      <!-- dialog comfirm Add -->
      <v-dialog max-width="464px" v-model="dialogConfirmAddEdit" persistent>
        <v-card max-height="300px" align="center">
          <v-toolbar color="#BDE7D9" dark dense elevation="0">
            <span class="flex text-center ml-5" style="font-size:20px" v-if="status === 'edit'"><font color="#27AB9C">แก้ไขหมวดหมู่สินค้า</font></span>
            <span class="flex text-center ml-5" style="font-size:20px" v-else-if="status === 'delete'"><font color="#27AB9C">ลบหมวดหมู่สินค้า</font></span>
            <span class="flex text-center ml-5" style="font-size:20px" v-else><font color="#27AB9C">เพิ่มหมวดหมู่สินค้า</font></span>
            <v-btn icon dark @click="dialogConfirmAddEdit = false, catagoryName = ''">
              <v-icon color="#27AB9C">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <br/>
          <v-card-text class="mt-10 mb-4">
            <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;" v-if="status === 'edit'">คุณทำการแก้ไขหมวดหมู่สินค้า</span>
            <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;" v-else-if="status === 'delete'">คุณทำการลบหมวดหมู่สินค้า</span>
            <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;" v-else>คุณทำการเพิ่มหมวดหมู่สินค้า</span>
            <br/>
            <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">คุณต้องการทำรายการนี้ ใช่หรือไม่ ?</span>
          </v-card-text>
          <v-card-actions >
        <v-row justify="center" dense class="mb-4">
          <v-btn dense  dark outlined color="#27AB9C" class="pl-7 pr-7 mt-2" @click="dialogConfirmAddEdit = false, catagoryName = ''">ยกเลิก</v-btn>
          <v-btn dense  color="#27AB9C" class="ml-4 mt-2 pl-8 pr-8 white--text" @click="addEditCatagory()" v-if="status !== 'delete'">ตกลง</v-btn>
          <v-btn dense  color="#27AB9C" class="ml-4 mt-2 pl-8 pr-8 white--text" @click="deleteCatagory()" v-else>ลบ</v-btn>
        </v-row>
        </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialog Add Success -->
      <v-dialog v-model="dialogSuccess" persistent width="373">
        <v-card style="background: #FFFFFF; border-radius: 4px;" min-height="246px">
          <v-toolbar align="center" color="#BDE7D9" dark dense elevation="0">
            <span class="flex text-center ml-5" style="font-size:18px">
              <font color="#27AB9C" v-if="status === 'edit'">แก้ไขหมวดหมู่สินค้า</font>
              <font color="#27AB9C" v-else-if="status === 'delete'">ลบหมวดหมู่สินค้า</font>
              <font color="#27AB9C" v-else>เพิ่มหมวดหมู่สินค้า</font>
            </span>
            <v-btn icon dark @click="dialogSuccess = false, status = ''">
              <v-icon color="#27AB9C">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container>
            <v-card-text>
              <v-row justify="center" no-gutters dense>
                <v-col cols="12" align="center">
                  <v-img src="@/assets/ImageINET-Marketplace/ICONShop/successIcon.png" contain max-height="70" max-width="70"></v-img>
                </v-col>
                <v-col cols="12" align="center" class="mt-6">
                  <p style="font-weight: 500; font-size: 14px; line-height: 22px; color: color: #333333;" class="pt-0 mt-0">เสร็จสิ้น</p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>
<script>
import { Decode } from '@/services'
import moment from 'moment'
export default {
  data () {
    return {
      userDetailSelling: [],
      seller_shop_id: '',
      // tab
      StateStatus: 0,
      showCountRequest: 0,
      countAll: 0,
      countActive: 0,
      countInactive: 0,

      // table
      disableTable: false,
      search: '',
      page: 1,
      itemsPerPage: 5,
      headers: [
        { text: 'ชื่อ', value: 'category_name', filterable: true, sortable: false, align: 'start', width: '150px', class: 'backgroundTable fontTable--text' },
        { text: 'วันที่สร้าง', value: 'created_at', sortable: false, align: 'start', width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'สถานะ', value: 'status', filterable: false, sortable: false, align: 'start', width: '50px', class: 'backgroundTable fontTable--text' },
        { text: 'จัดการ', value: 'action', filterable: false, align: 'start', width: '120px', sortable: false, class: 'backgroundTable fontTable--text' },
        { text: 'ปิด - เปิด การใช้งาน', value: 'switch', filterable: false, sortable: false, width: '180px', class: 'backgroundTable fontTable--text' }
      ],
      catagoryAll: {
        all: [],
        active: [],
        inactive: []
      },
      catagoryList: [],
      catagoryStatus: '',

      // add edit cat
      status: '',
      dialogAddEdit: false,
      catagoryId: '',
      catagoryName: '',
      dialogConfirmAddEdit: false,
      dialogSuccess: false
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push('/Order/CategoryMobile').catch(() => {})
      } else {
        this.$router.push('/Order/Category').catch(() => {})
      }
    },
    StateStatus (val) {
      // console.log('state is', val)
      // console.log(this.catagoryList)
      if (val === 0) {
        this.catagoryList = this.catagoryAll.all !== undefined ? this.catagoryAll.all : []
        if (this.catagoryList.length === 0) {
          this.disableTable = true
          this.showCountRequest = 0
        } else {
          this.disableTable = false
        }
      } else if (val === 1) {
        this.catagoryList = this.catagoryAll.active !== undefined ? this.catagoryAll.active : []
        // console.log('data', this.catagoryList)
        if (this.catagoryList.length === 0) {
          this.disableTable = true
          this.showCountRequest = 0
        } else {
          this.disableTable = false
        }
      } else if (val === 2) {
        this.catagoryList = this.catagoryAll.inactive !== undefined ? this.catagoryAll.inactive : []
        // console.log('data', this.catagoryList)
        if (this.catagoryList.length === 0) {
          this.disableTable = true
          this.showCountRequest = 0
        } else {
          this.disableTable = false
        }
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  created () {
    // this.$EventBus.$emit('changeNav')
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      if (localStorage.getItem('UserDetailSelling') !== null) {
        this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
        this.seller_shop_id = this.userDetailSelling.seller_shop_id
      }
      this.getData()
    }
  },
  methods: {
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/SellerShopMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/SellerShop' }).catch(() => {})
      }
    },
    getErrorMsg (msg) {
      if (msg === 'This user is unauthorized.') {
        return ['กรุณาเข้าสู่ระบบใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Shop not found.') {
        return ['ไม่พบร้านค้า', 'warning']
      } else if (msg === 'You are not employee in this Shop.') {
        return ['คุณไม่ใช่พนักงานในร้านค้านี้', 'warning']
      } else if (msg === 'Data missing. Please check your [" seller_shop_id "] and try again.') {
        return ['ข้อมูลขาดหาย โปรดเช็ค [ รหัสร้านค้า ] แล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'An error has occurred. Please try again in an hour or two.') {
        return ['กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง', 'error']
      } else if (msg === 'Catagory Already Exist.') {
        return ['หมวดหมู่นี้มีแล้ว', 'warning']
      } else {
        return [msg, 'error']
      }
    },
    getRequest (item) {
      this.StateStatus = item
      // i dnk
      this.page = 1
    },
    countRequest (pagination) {
      // console.log(pagination)
      this.showCountRequest = pagination.itemsLength
    },
    async getData () {
      this.$store.commit('openLoader')
      // reset data
      this.catagoryAll = {
        all: [],
        active: [],
        inactive: []
      }

      var data = {
        seller_shop_id: this.seller_shop_id
      }
      // console.log('data', data)
      await this.$store.dispatch('actionsGraczCategoryList', data)
      var res = await this.$store.state.ModuleGraczCategory.stateGraczCategoryList
      // console.log('res', res)
      if (res.result === 'SUCCESS') {
        var listCatagory = []
        listCatagory = res.data.list_category
        // console.log(listCatagory)
        // assign for new data
        this.catagoryAll.all = listCatagory
        if (listCatagory.length !== 0) {
          listCatagory.forEach(element => {
            element.status = element.status === 'active'
            if (element.status === true) {
              this.catagoryAll.active.push(element)
            } else {
              this.catagoryAll.inactive.push(element)
            }
          })
          this.disableTable = false
          this.countAll = this.catagoryAll.all.length
          this.countActive = this.catagoryAll.active.length
          this.countInactive = this.catagoryAll.inactive.length
        }
        // set data to show
        if (this.StateStatus === 0) {
          this.catagoryList = this.catagoryAll.all !== undefined ? this.catagoryAll.all : []
          if (this.catagoryList.length === 0) {
            this.disableTable = true
            this.showCountRequest = 0
          } else {
            this.disableTable = false
          }
        } else if (this.StateStatus === 1) {
          this.catagoryList = this.catagoryAll.active !== undefined ? this.catagoryAll.active : []
          if (this.catagoryList.length === 0) {
            this.disableTable = true
            this.showCountRequest = 0
          } else {
            this.disableTable = false
          }
        } else if (this.StateStatus === 2) {
          this.catagoryList = this.catagoryAll.inactive !== undefined ? this.catagoryAll.inactive : []
          if (this.catagoryList.length === 0) {
            this.disableTable = true
            this.showCountRequest = 0
          } else {
            this.disableTable = false
          }
        }
        this.$store.commit('closeLoader')
      } else {
        this.$store.commit('closeLoader')
        if (res.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(res.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
      // console.log('data send to API', data)
      // console.log('res from API', res)
      // console.log('this.catagoryAll', this.catagoryAll)
      // console.log('this.catagoryList', this.catagoryList)
    },
    edit (id) {
      this.status = 'edit'
      this.catagoryId = id
      this.catagoryList.forEach(element => {
        if (element.id === id) {
          this.catagoryName = element.category_name
          this.dialogAddEdit = true
        }
      })
    },
    dlt (id) {
      this.status = 'delete'
      this.catagoryId = id
      this.dialogConfirmAddEdit = true
    },
    async addEditCatagory () {
      var data = {}
      var res = ''
      if (this.status === 'edit') {
        data = {
          seller_shop_id: this.seller_shop_id,
          category_id: this.catagoryId,
          category_name: this.catagoryName
        }
        await this.$store.dispatch('actionsGraczEditCategory', data)
        res = await this.$store.state.ModuleGraczCategory.stateGraczEditCategory
      } else {
        data = {
          seller_shop_id: this.seller_shop_id,
          category_name: this.catagoryName
        }
        await this.$store.dispatch('actionsGraczCreateCategory', data)
        res = await this.$store.state.ModuleGraczCategory.stateGraczCreateCategory
      }
      this.dialogConfirmAddEdit = false
      this.catagoryName = ''
      if (res.result === 'SUCCESS') {
        this.dialogSuccess = true
        setTimeout(() => { this.dialogSuccess = false }, 1500)
        this.getData()
      } else {
        if (res.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(res.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
      this.catagoryId = ''
      this.catagoryName = ''
      // console.log(res)
    },
    async deleteCatagory () {
      this.dialogConfirmAddEdit = false
      var data = {
        seller_shop_id: this.seller_shop_id,
        category_id: this.catagoryId
      }
      await this.$store.dispatch('actionsGraczDeleteCategory', data)
      var res = await this.$store.state.ModuleGraczCategory.stateGraczDeleteCategory
      // var res = { result: 'SUCCESS' }
      console.log(res)
      if (res.result === 'SUCCESS') {
        this.dialogSuccess = true
        this.status = 'delete'
        setTimeout(() => { this.dialogSuccess = false }, 1500)
        this.getData()
      } else {
        if (res.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(res.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
      this.catagoryId = ''
      // this.status = ''
    },
    async switchStatus (id, status) {
      var data = {
        seller_shop_id: this.seller_shop_id,
        category_id: id
      }
      var text = status === false ? 'ปิดการใช้งานหมวดหมู่สำเร็จ' : 'เปิดการใช้งานหมวดหมู่สำเร็จ'
      await this.$store.dispatch('actionsGraczChangeStatusCategory', data)
      var res = await this.$store.state.ModuleGraczCategory.stateGraczChangeStatusCategory
      if (res.result === 'SUCCESS') {
        this.$swal.fire({ icon: 'success', text: `${status}สำเร็จ`, showConfirmButton: false, timer: 2000 })
        this.$swal.fire({ icon: 'success', text: text, showConfirmButton: false, timer: 2000 })
        await this.getData()
      } else {
        if (res.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(res.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    formatDateTH (date) {
      var year = moment(date).locale('TH').add('Year', 543).format('YYYY')
      var dateTH = moment(date).locale('TH').format('D MMMM ' + year)
      return dateTH
    },
    closeDialog () {
      this.catagoryId = ''
      this.catagoryName = ''
      this.status = ''
      this.dialogAddEdit = false
    }
  }
}
</script>
<style scoped>
.fontCount {
  font-weight: 600; font-size: 16px; line-height: 24px; color: #333333;
}
.fontSizeTitle2 {
  font-weight: 400; font-size: 18px; line-height: 24px; color: #333333;
}
.theme--light.v-input {
  padding-top: 0px !important;
  margin-top: 0px !important;
}
</style>
<style lang="scss" scoped>
  ::v-deep table {
    tbody {
      tr {
        td:nth-child(4) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 140px;
          z-index: 10;
          background: white;
        }
        td:nth-child(5) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: -20px;
          z-index: 10;
          background: white;
        }
      }
    }
    thead {
      tr {
        th:nth-child(4) {
          z-index: 11;
          background: white;
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 140px;
        }
        th:nth-child(5) {
          z-index: 11;
          background: white;
          position: sticky !important;
          position: -webkit-sticky !important;
          right: -20px;
        }
      }
    }
  }
</style>
